import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Edit = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "m6.067 17.48-.097.04-3.655 1.191a1.2 1.2 0 0 1-.253.039.83.83 0 0 1-.793-.627c-.01-.049-.01-.088-.019-.136 0-.098.01-.195.039-.302l.9-2.747.29-.91.04-.097a.155.155 0 0 1 .155-.116.16.16 0 0 1 .127.048l1.074 1.075 2.26 2.26a.172.172 0 0 1-.068.283Zm7.563-7.38-3.16 3.16-1.69 1.683-1.007 1.006-1.006-1.006-2.717-2.718 1.19-1.192.618-.617 3.286-3.297 5.41-5.412c.087-.087.185-.156.282-.214.253-.165.55-.243.831-.243.399 0 .802.156 1.113.462l1.507 1.507a1.576 1.576 0 0 1 0 2.232l-4.652 4.654z" }) }));
});
Edit.displayName = 'Edit';
Edit.__iconComponentType = 'standard';
export default Edit;
//# sourceMappingURL=Edit.js.map